/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  AbstractFinderGridDefinition,
  rendererIconByName,
  truthyCellRenderer,
} from '@gh/common-internal-shared';
import { NumberTypes } from '@gh/common-shared';

import { TranslationService } from '@gh/core-mls';
import { buildNumberColumn } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { getSalesTaxRateListItemId } from '../../resources/sales-rate-rate.model';

@Injectable()
export class SalesTaxRateFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getSalesTaxRateListItemId;

  constructor(private translationService: TranslationService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      { field: 'name', headerName: this.translationService.get('lbl_name'), width: 250 },
      {
        field: 'rate',
        headerName: this.translationService.get('lbl_rate'),
        width: 80,
        ...buildNumberColumn(NumberTypes.Rate),
      },
      {
        field: 'isDefault',
        headerName: this.translationService.get('lbl_default_rate'),
        width: 170,
        cellRenderer: truthyCellRenderer(rendererIconByName('done')),
      },
    ];
  }
}
